export { default } from './BrowserNotes';


// WEBPACK FOOTER //
// ./src/components/BrowserNotes/index.js